import React from 'react'
import { useTranslations } from 'next-intl'
import { Button } from '@node-space/ui-components'

interface ChangeProtocolButtonProps {
  isMultiProtocolCurrency: boolean
  onClick: () => void
}

export const ChangeProtocolButton = ({
  isMultiProtocolCurrency,

  onClick,
}: ChangeProtocolButtonProps) => {
  const t = useTranslations()

  return (
    isMultiProtocolCurrency && (
      <div className="flex w-full justify-center pt-3">
        <Button variant="ghost" full onClick={onClick}>
          {t('changeProtocol')}
        </Button>
      </div>
    )
  )
}
